import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/dashboard/efficiency/')({
  beforeLoad: () => {
    throw redirect({
      to: '/dashboard/efficiency/$canvasId',
      params: { canvasId: 'summary' },
    });
  },
});
